import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface RendezVousButtonProps {
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
}

const RendezVousButton: React.FC<RendezVousButtonProps> = ({ onClick, className = '', children }) => {
  const content = children || 'RENDEZVOUS';

  if (onClick) {
    return (
      <Button variant="luxury" size="lg" onClick={onClick} className={`mt-4 px-10 py-4 h-auto text-lg tracking-wide ${className}`}>
        {content}
      </Button>
    );
  }

  return (
    <Button asChild variant="luxury" size="lg" className={`mt-4 px-10 py-4 h-auto text-lg tracking-wide ${className}`}>
      <Link to="/appointments">{content}</Link>
    </Button>
  );
};

export default RendezVousButton;
